import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DefaultLayout from '../../layout/DefaultLayout';
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import Alert from '../../components/Alert';
import { toCurrency } from '../../utils/formaters';

const STORAGE_KEY = 'pagoPlanTemporal';

const CallbackPagoPlanFalla: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [error, setError] = useState<string | undefined>(undefined);
  const [pagoPlanTemporal, setPagoPlanTemporal] = useState<any | undefined>(undefined);

  useEffect(() => {
    try {
      const pagoPlanTemporalJson = localStorage.getItem(STORAGE_KEY);
      if (pagoPlanTemporalJson) {
        setPagoPlanTemporal(JSON.parse(pagoPlanTemporalJson));
      }
    } catch {
      // No bloquear la vista si no se puede leer
    }
  }, []);

  const volverInicio = () => navigate('/');

  return (
    <DefaultLayout>
      <Breadcrumb pageName="Pago Plan - Falla" />
      <div className="p-6">
        <div className="md:max-w-3xl mx-auto bg-white md:p-6 rounded">
          {/* Mensaje principal */}
          <div className="flex flex-col items-center text-center">
            <div className="bg-red-100 text-red-700 rounded-full w-20 h-20 flex items-center justify-center mb-4">
              <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" fill="currentColor" opacity="0.2" />
                <path d="M8 8l8 8M16 8l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold mb-2">Tu pago no pudo ser procesado</h2>
            <p className="text-sm text-gray-600 mb-6">
              Se produjo un error al procesar tu pago. Por favor, reintenta más tarde.
            </p>
          </div>

          {error && <Alert type="failure" message={error} />}

          {/* Detalle (si está disponible) */}
          <div className="bg-gray-50 rounded p-4">
            <div className="grid grid-cols-2 gap-3">
              <div className="text-sm text-gray-700">Plan de Pago</div>
              <div className="text-sm font-semibold text-right">Una Cuota</div>

              <div className="text-sm text-gray-700">Concepto</div>
              <div className="text-sm font-semibold text-right">{pagoPlanTemporal?.metadata?.descripcion ?? '-'}</div>

              <div className="text-sm text-gray-700">Monto</div>
              <div className="text-sm font-bold text-right">
                {pagoPlanTemporal?.monto !== undefined ? toCurrency(pagoPlanTemporal.monto) : '-'}
              </div>

              <div className="text-sm text-gray-700">Ruta actual</div>
              <div className="text-sm font-bold text-right">{location.pathname}</div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <button
              onClick={volverInicio}
              className="px-6 py-3 rounded font-semibold text-white bg-primario-celeste-800"
            >
              Volver al inicio
            </button>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default CallbackPagoPlanFalla;